import About from "../components/About";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import Hero from "../components/Hero";
import Projects from "../components/Projects";
import Publications from "../components/Publications";
import Stack from "../components/Stack";
import { defaults, usePageMeta } from "../hooks/useDocumentTitle";

export default function Home() {
    usePageMeta({
        title: defaults.title,
        description: defaults.description,
        path: "/",
    });

    return (
        <>
            <main className="page">
                <Hero />
                <About />
                <Stack />
                <Projects />
                <Publications />
                <Contact />
            </main>
            <Footer />
        </>
    );
}
